/* eslint-disable */
// @ts-nocheck
import axios from 'axios';
import { useCallback } from 'react';
import { useDispatch } from 'react-redux';
import { useNavigate } from 'react-router-dom';
import { useConfig } from '../../../config/useConfig';
import { useAppSelector } from '../../../store/hooks';
import {
  removeUserData,
  setLoader,
  setOpenMsg,
  setReport,
  setUserData,
  updateEmail,
} from '../../../store/user.slice';
import { errorMessage } from '../../../utils';

export const useLogin = () => {
  const { apiInstance } = useConfig();
  const dispatch = useDispatch();
  const { userData } = useAppSelector((state) => state.user);
  const navigate = useNavigate();

  const getAnalyticsReport = useCallback(async (payload) => {
    dispatch(setLoader(true));
    const { token, user } = userData || {};
    const updatedPayload = { ...payload, userId: user?._id };
    try {
      const { data } = await apiInstance.post('/user/analytics-report', updatedPayload, {
        headers: {
          authorization: 'bearer ' + token,
        },
      });
      if (data?.message === 'Successfully Generated Analytics Report') {
        dispatch(setOpenMsg({ text: data.message, severity: 'success' }));
        dispatch(setReport({ report1: data.report1, report2: data.report2 }));
      } else {
        dispatch(setOpenMsg({ text: data.message, severity: 'warning' }));
      }
    } catch (error) {
      if (axios.isAxiosError(error)) {
        dispatch(setOpenMsg({ text: errorMessage(error), severity: 'error' }));
      }
    } finally {
      dispatch(setLoader(false));
    }
  }, []);

  const sendFeedback = useCallback(async (payload, callBack) => {
    dispatch(setLoader(true));
    try {
      const { data } = await apiInstance.post('/user/send-feedback', payload);
      if (data?.status) {
        dispatch(setOpenMsg({ text: data.message, severity: 'success' }));
        callBack();
      } else {
        dispatch(setOpenMsg({ text: data.message, severity: 'warning' }));
      }
    } catch (error) {
      if (axios.isAxiosError(error)) {
        dispatch(setOpenMsg({ text: errorMessage(error), severity: 'error' }));
      }
    } finally {
      dispatch(setLoader(false));
    }
  }, []);

  const signUp = useCallback(async (payload, callBack) => {
    dispatch(setLoader(true));
    try {
      const { data } = await apiInstance.post('/user/register', payload);
      if (data?.status) {
        dispatch(setOpenMsg({ text: data.message, severity: 'success' }));
        callBack();
      } else {
        dispatch(setOpenMsg({ text: data.message, severity: 'warning' }));
      }
    } catch (error) {
      if (axios.isAxiosError(error)) {
        dispatch(setOpenMsg({ text: errorMessage(error), severity: 'error' }));
      }
    } finally {
      dispatch(setLoader(false));
    }
  }, []);

  const signIn = useCallback(async (payload, callBack) => {
    dispatch(setLoader(true));
    try {
      const { data } = await apiInstance.post('/user/login', payload);
      if (data?.status) {
        const { isAdmin, token, user, message } = data;
        const decryptedString = atob(user);
        const userData = decryptedString && JSON.parse(decryptedString);
        dispatch(setUserData({ isAdmin, token, user: userData, email: payload.email }));
        dispatch(setOpenMsg({ text: message, severity: 'success' }));
        callBack();
      } else {
        dispatch(setOpenMsg({ text: data.message, severity: 'warning' }));
      }
    } catch (error) {
      if (axios.isAxiosError(error)) {
        dispatch(setOpenMsg({ text: errorMessage(error), severity: 'error' }));
      }
    } finally {
      dispatch(setLoader(false));
    }
  }, []);

  const logout = useCallback(async () => {
    dispatch(setLoader(true));
    const { token } = userData || {};
    try {
      const { data } = await apiInstance.post(
        '/user/logout',
        {},
        {
          headers: {
            authorization: 'bearer ' + token,
          },
        },
      );
      if (data?.status) {
        dispatch(setOpenMsg({ text: data.message, severity: 'success' }));
        dispatch(removeUserData());
      } else {
        dispatch(setOpenMsg({ text: data.message, severity: 'warning' }));
      }
    } catch (error) {
      if (axios.isAxiosError(error)) {
        dispatch(setOpenMsg({ text: errorMessage(error), severity: 'error' }));
      }
    } finally {
      dispatch(setLoader(false));
    }
  }, []);

  const getEmailOtp = useCallback(async (callBack) => {
    dispatch(setLoader(true));
    const { token } = userData || {};
    try {
      const { data } = await apiInstance.post(
        '/user/trigger-email-change-opt',
        { email: userData?.user?.email },
        {
          headers: {
            authorization: 'bearer ' + token,
          },
        },
      );
      if (data?.status) {
        callBack('email');
        dispatch(setOpenMsg({ text: data.message, severity: 'success' }));
      } else {
        dispatch(setOpenMsg({ text: data.message, severity: 'warning' }));
      }
    } catch (error) {
      if (axios.isAxiosError(error)) {
        dispatch(setOpenMsg({ text: errorMessage(error), severity: 'error' }));
      }
    } finally {
      dispatch(setLoader(false));
    }
  }, []);

  const getPasswordOtp = useCallback(async (callBack) => {
    dispatch(setLoader(true));
    const { token } = userData || {};
    try {
      const { data } = await apiInstance.post(
        '/user/trigger-password-change-opt',
        { email: userData?.user?.email },
        {
          headers: {
            authorization: 'bearer ' + token,
          },
        },
      );
      if (data?.status) {
        callBack('password');
        dispatch(setOpenMsg({ text: data.message, severity: 'success' }));
      } else {
        dispatch(setOpenMsg({ text: data.message, severity: 'warning' }));
      }
    } catch (error) {
      if (axios.isAxiosError(error)) {
        dispatch(setOpenMsg({ text: errorMessage(error), severity: 'error' }));
      }
    } finally {
      dispatch(setLoader(false));
    }
  }, []);

  const changeEmail = useCallback(async (payload, callBack) => {
    dispatch(setLoader(true));
    const { token } = userData || {};
    try {
      const { data } = await apiInstance.post('/user/change-email-using-otp', payload, {
        headers: {
          authorization: 'bearer ' + token,
        },
      });
      if (data?.status) {
        callBack(null);
        dispatch(
          updateEmail({ ...userData, user: { ...userData?.user, email: payload.newEmail } }),
        );
        dispatch(setOpenMsg({ text: data.message, severity: 'success' }));
      } else {
        dispatch(setOpenMsg({ text: data.message, severity: 'warning' }));
      }
    } catch (error) {
      if (axios.isAxiosError(error)) {
        dispatch(setOpenMsg({ text: errorMessage(error), severity: 'error' }));
      }
    } finally {
      dispatch(setLoader(false));
    }
  }, []);

  const changePassword = useCallback(async (payload, callBack) => {
    dispatch(setLoader(true));
    const { token } = userData || {};
    delete payload.password;
    try {
      const { data } = await apiInstance.post('/user/change-password-using-otp', payload, {
        headers: {
          authorization: 'bearer ' + token,
        },
      });
      if (data?.status) {
        callBack(null);
        dispatch(setOpenMsg({ text: data.message, severity: 'success' }));
      } else {
        dispatch(setOpenMsg({ text: data.message, severity: 'warning' }));
      }
    } catch (error) {
      if (axios.isAxiosError(error)) {
        dispatch(setOpenMsg({ text: errorMessage(error), severity: 'error' }));
      }
    } finally {
      dispatch(setLoader(false));
    }
  }, []);

  const deleteAccount = useCallback(async (handleModalClose, closeAllModal) => {
    dispatch(setLoader(true));
    const { token } = userData || {};
    try {
      const { data } = await apiInstance.post(
        '/user/delete-user-account',
        { email: userData?.user?.email },
        {
          headers: {
            authorization: 'bearer ' + token,
          },
        },
      );

      if (data?.status) {
        dispatch(setOpenMsg({ text: data.message, severity: 'success' }));
        dispatch(removeUserData());
        closeAllModal();
        navigate('goBack');
      } else {
        dispatch(setOpenMsg({ text: data.message, severity: 'warning' }));
      }
    } catch (error) {
      if (axios.isAxiosError(error)) {
        dispatch(setOpenMsg({ text: errorMessage(error), severity: 'error' }));
      }
    } finally {
      dispatch(setLoader(false));
      handleModalClose();
    }
  }, []);

  return {
    signUp,
    signIn,
    logout,
    getPasswordOtp,
    getEmailOtp,
    changeEmail,
    changePassword,
    deleteAccount,
    getAnalyticsReport,
    sendFeedback,
  };
};
